import { html, LitElement } from 'lit-element';
import 'lm-ui-kit/src/components/uc-button/uc-button.define';
import { styles } from './uc-footer-info.styles';

export class UcFooterInfo extends LitElement {
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div subscription-terms="">
        Подписываясь на рассылку, я даю
        <a
          href="https://leroymerlin.ru/personal-data-docs/"
          target="_blank"
          rel="noopener noreferrer"
          style="text-decoration: none; color: #66c05d"
        >
          согласие
        </a>
        на обработку персональных данных и на получение рекламных сообщений и новостей о товарах и услугах.
        Сайт защищён системой reCAPTCHA, к нему применяется политика
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          style="text-decoration: none; color: #66c05d"
        >
          конфиденциальности
        </a>
        и
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          style="text-decoration: none; color: #66c05d"
        >
          условия использования Google.
        </a>
      </div>
    `;
  }
}
